export const base_url = "https://travel-website-backend-c59w.onrender.com";
// https://travel-website-backend-c59w.onrender.com